<div class="absolute h-screen w-screen top-0 left-0 flex items-center justify-center bg-gray-50/50 backdrop-blur-sm z-1">
  <mat-spinner></mat-spinner>
</div>
